import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1758732c")

_pushScopeId("data-v-1758732c")
const _hoisted_1 = { class: "pb-32" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Trade More, Profit More")
const _hoisted_3 = { class: "d-f mt-16 px-20" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Your average daily trade amount last week is ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". Double it to ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" this week to get a ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" coupon! ")
const _hoisted_8 = { class: "df-middle coupon-bg mt-12" }
const _hoisted_9 = { class: "mt-wrap df-between df-middle br-lg px-16" }
const _hoisted_10 = { class: "pro-wrap br-lg d-f flex-1 px-8 py-4" }
const _hoisted_11 = { class: "main-bg br-sm flex-1" }
const _hoisted_12 = { class: "f-bold ml-24 df-middle" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("This week:")
const _hoisted_14 = { class: "c-success ml-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_money = _resolveComponent("money")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_58",
      class: "t-center f-xxl f-bold"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_t, {
        as: "p",
        path: "home_59",
        args: {last: '$' + _ctx.div(_ctx.info.amount, _ctx.format.moneyFactor),
      this: '$' + _ctx.div(_ctx.info.targetAmount, _ctx.format.moneyFactor),
      coupon: '$' + _ctx.div(_ctx.info.voucherAmount, _ctx.format.moneyFactor)},
        class: "mr-16",
        style: {"line-height":"20px"}
      }, {
        default: _withId(() => [
          _hoisted_4,
          _createVNode(_component_money, {
            v: _ctx.info.amount
          }, null, 8, ["v"]),
          _hoisted_5,
          _createVNode(_component_money, {
            v: _ctx.info.targetAmount
          }, null, 8, ["v"]),
          _hoisted_6,
          _createVNode(_component_money, {
            v: _ctx.info.voucherAmount
          }, null, 8, ["v"]),
          _hoisted_7
        ]),
        _: 1
      }, 8, ["args"]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_money, {
          class: "c-white f-bold",
          style: {"font-size":"21px"},
          v: _ctx.info.voucherAmount
        }, null, 8, ["v"])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", {
            class: "main-pro br-sm",
            style: `width: ${_ctx.persent}%;`
          }, null, 4)
        ])
      ]),
      _createVNode("p", _hoisted_12, [
        _createVNode(_component_t, { path: "home_60" }, {
          default: _withId(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode("span", _hoisted_14, [
          _createVNode(_component_money, {
            v: _ctx.info.averateAmount
          }, null, 8, ["v"])
        ])
      ])
    ])
  ]))
})